<template>
    <md-dialog class="add_dialog" title="Transfer To" :closable="true" v-model="dialogopen" :btns="btns">
        <md-field :title="'Transfer to ' + to_cwid">
            <div
                class="field-operator"
                slot="action"
                @click="bonusratio_onClick"
            >
                <md-icon name="info"></md-icon>
            </div>
            <md-input-item
                type="money"
                v-model="quota"
                :brief="quota_brief"
                :placeholder="'Max: ' + max_quota + 'Itoken'"
                :size="size"
                is-amount
                is-highlight
                :maxlength="8"
            >
                <div class="input-operator" slot="right" @click="set_max">Max</div>
            </md-input-item>
        </md-field>
    </md-dialog>
</template>
<script>
import { transfertochild } from '@/request/api'
export default {
    name: 'transfertochild',
    props: {
        to: {
            type: Object,
            default: {}
        }
    },
    data(){
        return {
            dialogopen: false,
            btns: [
                {
                    text: 'Cancel',
                    handler: this.onDialogCancel,
                },
                {
                    text: 'Transfer out',
                    handler: this.onDialogConfirm,
                },
            ],
            quota: "",
            max_quota: 0,
            quota_brief: "Your Itoken Balance: 0",
            to_cwid: "",
        }
    },
    computed: {
        size() {
            return 'small'
        },
    },
    created() {
        this.refresh_userinfo();
    },
    methods: {
        refresh_userinfo() {
            this.$store.dispatch('asyncupdateuserinfo').then(res=>{
                this.max_quota = res.itoken;
                this.quota_brief = "Your Itoken Balance: " + res.itoken
            });
        },
        onDialogCancel() {
			this.dialogopen = false;
		},
        showdialog() {
            this.to_cwid = this.to.collectionworkerid;
            this.quota = "";
            this.dialogopen = true;
        },
        set_max() {
            this.quota = this.$store.state.userinfo.itoken;
        },
        bonusratio_onClick() {
            Toast({
                content: 'Max ' + this.$store.state.userinfo.itoken,
                icon: 'warn',
            })
        },
        onDialogConfirm() {
            if(Number(this.quota) > this.max_quota) {
                this.$toast.failed('Max ' + this.max_quota);
                return;
            }
            if(this.to_cwid === "") {
                this.$toast.failed('please choose cw');
                return;
            } 
            this.$toast.loading('in progress...')
            transfertochild({
                to: this.to_cwid,
                quota: this.quota
            }).then(res=>{
                this.$toast.hide();
                if(res.code === 200) {
                    this.onDialogCancel();
                    this.$emit("success");
                    this.refresh_userinfo();
                } else {
                    this.$toast.failed(res.errmsg);
                }
            })

		},
    }
}

</script>

<style scoped>
.add_dialog >>> .md-dialog-body {
    padding: 0.52rem 0 0 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/transfertochild.vue